import { request } from "../../FlowEditPage/request";

/**
 * 清空 n8n 测试对话记录
 * 幂等：chatId 不存在也返回成功
 *
 * @param chatId 测试会话 ID
 */
export function clearN8nTestHistoryService(chatId: string) {
  return request<API.BaseResponse>(
    `/api/damselfish-chat-bot/n8nTest/clear/${chatId}`,
    {
      method: "PUT",
    }
  );
}
